// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c37b96b","638":"7811c3e3","953":"a00ce05c"}[chunkId] + ".chunk.js";
};